import { useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import initializeAOS from "../utils/aosLibrary";
import dot2_vector from "../../src/assets//dot2-vector.svg";
import dot3_vector from "../../src/assets//dot3-vector.svg";
import line_3 from "../../src/assets//new_line_vector.svg";
import { useTranslation } from "react-i18next";

function EnouthTalk() {
  const { t } = useTranslation();
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const fontLivic = "Livvic , sans-serif";
  useEffect(() => {
    initializeAOS();
  }, []);

  return (
    <div
      data-aos="fade-up"
      style={{
        position: "relative",
        borderRadius: "40px",
        height: isXs ? "450px" : "auto",
        padding: isXs ? "0" : "40px 20px",
        margin: isXs ? "90px 60px" : "90px 20px",
        background:
          "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
        gap: "20px",
      }}
    >
      <div
        style={{
          fontSize: isXs ? "50px" : "34px",
          fontWeight: "lighter",
          fontWeight: "300",
        }}
      >
        {" "}
        {t('home_page.section_5.heading')}
      </div>
      <div style={{ fontFamily: fontLivic, fontSize: "18px", padding: "0 30px" }}>
      {t('home_page.section_5.description')}
        
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          paddingTop: "30px",
        }}
      >
        <div
          style={{
            backgroundColor: "#512CEB",
            width: "170px",
            color: "white",
            padding: "12px 25px",
            fontWeight: "bold",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.6)",
          }}
        >
          {" "}
          <a
            style={{ textDecoration: "none", color: "white" }}
            href="/contact-us"
          >
            {t('home_page.section_5.cta_button')}
          </a>{" "}
        </div>
        {/* <div style={{border:'1px solid black', width:'170px', padding:'12px 25px', borderRadius:'20px', fontWeight:'bold'}}><a style={{textDecoration:'none', color:"black"}} href='/services'>Our Services</a> </div> */}
      </div>
      <img
        style={{
          height: isXs ? "200px" : "100px",
          position: "absolute",
          top: "0px",
        }}
        src={line_3}
        alt=""
      />
      <img
        src={dot2_vector}
        loading="lazy"
        alt="Hero Shape Image"
        className="hero-shape-2"
        style={{
          display: isXs ? "flex" : "none",
          animation: "moveUpDown 2s infinite alternate",
          position: "absolute",
          top: "400px",
          left: "30px",
        }}
      />
      <img
        src={dot3_vector}
        loading="lazy"
        alt="Hero Shape Image"
        className="hero-shape-2"
        style={{
          display: isXs ? "flex" : "none",
          animation: "moveUpDown 2s infinite alternate",
          position: "absolute",
          top: "100px",
          right: "30px",
        }}
      />
    </div>
  );
}

export default EnouthTalk;

